const FindCohortIDRegex = new RegExp(/treatment_?([b-z])/, "i");

export function isControlCohort(cohort) {
  // Check for control and off cohort string
  const controlTest = /(control|off)/i;

  return controlTest.test(cohort);
}

// Convert Hivemind cohort to b-z(used by campaign ID)
// Possible cohort naming:
// * treatment, treatmentB, treatment_B
//   check src/commons/constants/experiment.ts for more details
export const getCampaignCohortID = (
  inTreatmentCohort: boolean,
  cohort: string | undefined
) => {
  if (!inTreatmentCohort || !cohort) {
    return "a";
  }

  const match = cohort.match(FindCohortIDRegex);
  if (!match) {
    return "b";
  }

  return match[1].toLocaleLowerCase();
};
